import { Logo } from '@vgrubs/components';

export const LocationImage = ({
  imageUrl,
  size = 50,
}: {
  imageUrl?: string | null;
  size?: number;
}) => {
  return imageUrl ? (
    <img
      src={imageUrl}
      alt="location"
      width={size}
      height={size}
      style={{ borderRadius: '50%' }}
    />
  ) : (
    <Logo width={size} height={size} />
  );
};
